import { useParams } from 'react-router';
import { OrderForm } from './OrderForm';
import { OrderFormProvider } from './OrderFormContext';

export default function PublicEventOrderForm() {
  const { formId } = useParams<{ formId?: string }>();
  return (
    <OrderFormProvider sharedLinkId={formId}>
      <OrderForm />
    </OrderFormProvider>
  );
}
